import { appRouting } from 'v5/core/routing/appRouting';
import { myRouting } from 'v5/features/core/routing';
import { useRouteMatch } from 'react-router-dom';

function parseNumericRouteParam(value: string | undefined): number | null {
  if (!value) {
    return null;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
}

export function useCurrentResourceId() {
  const legacyMatch = useRouteMatch<{ id: string }>({
    path: myRouting.forWorkspace().contacts().detail(),
    exact: false
  });
  const enterpriseMatch = useRouteMatch<{ id: string }>({
    path: appRouting.org().workspace().contacts.detail(),
    exact: false
  });

  return (
    parseNumericRouteParam(legacyMatch?.params?.id) ??
    parseNumericRouteParam(enterpriseMatch?.params?.id)
  );
}

export function useCurrentResourceTypeId() {
  const legacyMatch = useRouteMatch<{ id: string }>({
    path: '/app/:app_id/resources/:id',
    exact: true
  });
  const enterpriseMatch = useRouteMatch<{ resourceTypeId: string }>({
    path: appRouting.org().workspace().resources.forResourceType(),
    exact: true
  });

  return (
    parseNumericRouteParam(legacyMatch?.params?.id) ??
    parseNumericRouteParam(enterpriseMatch?.params?.resourceTypeId)
  );
}
